module.exports = __webpack_public_path__ + "img/value-3.3fdc7cbd.svg";